import { ReactNotificationOptions, store } from "react-notifications-component";

export const createNotification = (title: string, message: string, type: ReactNotificationOptions['type'] = 'success') => {
    store.addNotification({
        title,
        message,
        type,
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
            duration: 7000,
            onScreen: true,
        },
    });
}